export const SET_SKILLS = 'SET_SKILLS';
export const SET_CERTIFICATES = 'SET_CERTIFICATES';
export const SET_WORKS = 'SET_WORKS';
export const SET_WORK = 'SET_WORK';
export const SET_CONTACT = 'SET_CONTACT';
export const SET_BENEFITS = 'SET_BENEFITS';
export const SET_INTEREST = 'SET_INTEREST';
export const SET_CATEGORIES = 'SET_CATEGORIES';
